<div class="card-header elevation-1 p-inset-squish-xs bg-color-neutral-200 border-width-sm border-color-neutral-300" role="tab" id="heading_{{key}}">
  <h4 class="card-title">
    <a role="button" class="link p1 no-underline" id="collapse_{{key}}" data-toggle="collapse" data-parent="#accordion" href="#panel_{{key}}" aria-expanded="true" aria-controls="collapse_{{key}}">
      {{t title}}
    </a>
  </h4>
  <div class="progress-buttons">
    {{#if completed}}
      <button class="btn btn-compact btn-primary" disabled="disabled">Module Complete</button>
    {{else}}
      <button class="btn btn-primary btn-compact bg-color-success-base progress-grant-all" data-module="{{key}}">Grant Progress</button>
    {{/if}}
    {{#if local}}
      <button class="btn btn-primary btn-compact bg-color-error-base progress-remove-all" data-module="{{key}}">Clear Progress</button>
    {{/if}}
  </div>
</div>
<div id="panel_{{key}}" class="module-panel collapse {{#if wasOpen}}show{{/if}}" role="tabpanel" aria-labelledby="heading_{{key}}">
  <div class="card-body table-container m-stack-md">
    <table class="table">
      <tr class="table__row text-left">
        <th class="table__cell bold p-inset-xs">Activity Key</th>
        <th class="table__cell bold p-inset-xs">Page Key</th>
        <th class="table__cell bold p-inset-xs">Complete</th>
        <th class="table__cell bold p-inset-xs"></th>
      </tr>
      {{#each activities}}
        {{#each pages}}
          <tr class="table__row">
            <td class="table__cell p-inset-xs">{{../key}}</td>
            <td class="table__cell p-inset-xs"><a href="#{{../../key}}/{{../key}}/{{key}}" data-close="true" class="link">{{key}}</a></td>
            <td class="table__cell p-inset-xs">{{completed}}</td>
            <td class="table__cell p-inset-xs">
              {{#if completed}}
                {{#if ../../local}}
                  <button class="btn btn-primary btn-compact btn-progress bg-color-error-base" data-module="{{../../key}}" data-activity="{{../key}}"
                          data-page="{{key}}">Remove</button>
                {{else}}
                  <button class="btn btn-primary btn-compact btn-primary" disabled="disabled">Complete</button>
                {{/if}}
              {{else}}
                <button class="btn btn-primary btn-compact btn-progress bg-color-success-base" data-module="{{../../key}}" data-activity="{{../key}}"
                        data-page="{{key}}">Add</button>
              {{/if}}
            </td>
          </tr>
        {{/each}}
      {{/each}}
    </table>
  </div>
</div>
